/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Resync_DescriptionInputs */



/**
* | output |
* | --- |
* | "Clear local database and re-download all data from server" |
*
* @param {Profile_Resync_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_resync_description = /** @type {((inputs?: Profile_Resync_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Resync_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer la base de données locale et retélécharger toutes les données du serveur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Limpiar base de datos local y volver a descargar todos los datos del servidor")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Limpar banco de dados local e baixar novamente todos os dados do servidor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella il database locale e riscarica tutti i dati dal server")
	return /** @type {LocalizedString} */ ("Clear local database and re-download all data from server")
});